export const TAB_OVERVIEW = '1';
export const TAB_RATING = '2';
